import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { CourseArt } from "@/components/common/CourseArt";
import { PROJECTS } from "@/lib/site";

const ProjectCard = ({ p, i, big }) => (
  <Reveal delay={i * 0.07} as="article" className={big ? "md:col-span-2 md:row-span-2" : ""}>
    <div className={`group relative flex h-full flex-col overflow-hidden rounded-card border border-ink/10 ${p.color} p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1`}
      data-testid={`project-card-${i}`}>
      <span className="w-fit rounded-full bg-white/80 px-3 py-1 text-xs font-bold uppercase tracking-wider">{p.course}</span>
      <h3 className={`mt-4 font-semibold ${big ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{p.title}</h3>
      <p className="mt-3 max-w-md text-ink-soft leading-relaxed">{p.text}</p>
      {big && (
        <div className="mt-6 flex-1 min-h-[200px] overflow-hidden rounded-2xl border border-ink/10 bg-cream">
          <CourseArt name="filter" className="h-full w-full p-6 transition-transform duration-500 group-hover:scale-105" />
        </div>
      )}
    </div>
  </Reveal>
);

export const ProjectsSection = () => (
  <section className="section-y" aria-labelledby="projects-title" data-testid="projects-section">
    <div className="container-x">
      <div className="relative">
        <SectionHeading id="projects-title" eyebrow="Student projects" title="Learning you can hold in your hands"
          intro="A taste of the kinds of projects learners take on. These are example project themes, not finished student work." />
      </div>
      <div className="mt-14 grid auto-rows-fr gap-6 md:grid-cols-4">
        {PROJECTS.map((p, i) => <ProjectCard key={p.title} p={p} i={i} big={i === 0} />)}
      </div>
    </div>
  </section>
);
